import React from 'react';
import {RequestServices} from "services";
import {useNavigate} from "react-router-dom";
import useRequestFetch from "react-requests-fetch";

interface Props  {
    url: string
}


const AccountSignInChecker = (ComposedComponent: React.ComponentType<Props>) => {

    const Checker: React.FC<Props> = (props) => {
        const navigate = useNavigate();
        const accessToken = localStorage.getItem("x-access-token");
        const [ payload, isLoading ] = useRequestFetch(RequestServices.checkTokenValid(String(accessToken)));


            if (accessToken !== null) {
                if (!isLoading && payload === 204) {
                    navigate("/admin/space")
                    return null;
                }
                if (payload !== undefined && (!isLoading && payload !== 204)) {
                    localStorage.removeItem("x-access-token")
                    navigate("/admin/sign_in")
                    return null;
                }
            } 
                return <ComposedComponent {...props} />

    };
    return Checker;
};

export { AccountSignInChecker };
